import { AaSigninReq } from 'app/bff/models/aa/aaSignin';
import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { MbUpdateinfoReq } from 'app/bff/models/mb/mbUpdateinfo';
import { ROUTES } from 'app/core/router/paths';
import { ProcessStepCodesEnum } from 'app/features/Member/Settings/Email/types';
import { FormValues as SetupFormValues } from 'app/features/Member/Settings/Email/Setup/types';

// State type
export interface EmailState {
  process: ProcessState;
}

interface ProcessState {
  accessibleSteps: ProcessStepCodesEnum[];
  setup: {
    data?: SetupFormValues;
    otpAuth: {
      email?: AaOtpSendcodeResp;
    };
  };
}
// ::: End

// Actions type constant
export const MEMBER_SETTING_EMAIL__SET_ACCESSIBLE_STEP = 'MEMBER_SETTING_EMAIL__SET_ACCESSIBLE_STEP';
export const MEMBER_SETTING_EMAIL__AUTH_PASS_PHRASE = 'MEMBER_SETTING_EMAIL__AUTH_PASS_PHRASE';
export const MEMBER_SETTING_EMAIL__SAVE_SETUP_PAGE_DATA = 'MEMBER_SETTING_EMAIL__SAVE_SETUP_PAGE_DATA';
export const MEMBER_SETTING_EMAIL__SEND_EMAIL_OTP = 'MEMBER_SETTING_EMAIL__SEND_EMAIL_OTP';
export const MEMBER_SETTING_EMAIL__SEND_EMAIL_OTP_DONE = 'MEMBER_SETTING_EMAIL__SEND_EMAIL_OTP_DONE';
export const MEMBER_SETTING_EMAIL__AUTH_EMAIL_OTP = 'MEMBER_SETTING_EMAIL__AUTH_EMAIL_OTP';
export const MEMBER_SETTING_EMAIL__SETUP_EMAIL = 'MEMBER_SETTING_EMAIL__SETUP_EMAIL';
export const MEMBER_SETTING_EMAIL__UPDATE_CACHE = 'MEMBER_SETTING_EMAIL__UPDATE_CACHE';
export const MEMBER_SETTING_EMAIL__RESET_CACHE = 'MEMBER_SETTING_EMAIL__RESET_CACHE';
// ::: End

// Action creators type
export interface SetAccessibleStepAction {
  type: typeof MEMBER_SETTING_EMAIL__SET_ACCESSIBLE_STEP;
  payload: {
    step: ProcessStepCodesEnum;
  };
}

export interface AuthPassPhraseAction {
  type: typeof MEMBER_SETTING_EMAIL__AUTH_PASS_PHRASE;
  payload: {
    args: AaSigninReq;
  };
}

export interface SaveSetupPageDataAction {
  type: typeof MEMBER_SETTING_EMAIL__SAVE_SETUP_PAGE_DATA;
  payload: {
    data: SetupFormValues;
  };
}

export interface SendEmailOTPAction {
  type: typeof MEMBER_SETTING_EMAIL__SEND_EMAIL_OTP;
  payload: {
    args: AaOtpSendcodeReq;
    redirectRoute?: ROUTES;
  };
}

export interface SendEmailOTPDoneAction {
  type: typeof MEMBER_SETTING_EMAIL__SEND_EMAIL_OTP_DONE;
  payload: {
    response: AaOtpSendcodeResp;
  };
}

export interface AuthEmailOTPAction {
  type: typeof MEMBER_SETTING_EMAIL__AUTH_EMAIL_OTP;
  payload: {
    authEmailOTPArgs: AaOtpVerifyReq;
    setupEmailArgs: MbUpdateinfoReq;
  };
}

export interface SetupEmailAction {
  type: typeof MEMBER_SETTING_EMAIL__SETUP_EMAIL;
  payload: {
    args: MbUpdateinfoReq;
  };
}

export interface UpdateCacheAction {
  type: typeof MEMBER_SETTING_EMAIL__UPDATE_CACHE;
  payload: {
    cache: EmailState;
  };
}

export interface ResetCacheAction {
  type: typeof MEMBER_SETTING_EMAIL__RESET_CACHE;
}

export type EmailActions =
    SetAccessibleStepAction
  | AuthPassPhraseAction
  | SaveSetupPageDataAction
  | SendEmailOTPAction
  | SendEmailOTPDoneAction
  | AuthEmailOTPAction
  | SetupEmailAction
  | UpdateCacheAction
  | ResetCacheAction;
// ::: End
